export const NOTIFICATION_PREF_KEYS = ['draws', 'jackpot', 'results', 'weekly'] as const;

export type NotificationPrefKey = (typeof NOTIFICATION_PREF_KEYS)[number];

export interface NotificationPrefRow {
  key: NotificationPrefKey;
  label: string;
  onboardingDescription: string;
}

export const NOTIFICATION_PREF_ROWS: readonly NotificationPrefRow[] = [
  {
    key: 'draws',
    label: 'Draw reminders',
    onboardingDescription: "Tonight's draw is in a few hours",
  },
  {
    key: 'jackpot',
    label: 'Jackpot alerts ($100M+)',
    onboardingDescription: 'When the jackpot passes $100M',
  },
  {
    key: 'results',
    label: 'Ticket result updates',
    onboardingDescription: 'When saved tickets have official results',
  },
  {
    key: 'weekly',
    label: 'Weekly digest',
    onboardingDescription: 'Your picks and recent results',
  },
] as const;
